import { CommonController } from './CommonController';
import { HomeSlider } from '../modules/Slider'
import { HomeMessage } from '../modules/HomeMessage'
import { HomeCrosstalk } from '../modules/HomeCrosstalk'
import { Modal } from '../modules/Modal'

export class HomeController extends CommonController {
  onInit() {
    super.onInit();
    // FVのhomeMvはwindow.loadを待たず、DOM準備後に優先してmountする
    new HomeSlider();
    new HomeMessage();
    new HomeCrosstalk();
  }
  onLoad() {
    super.onLoad();
    new Modal();
  }
  onDestroy() {
    super.onDestroy();
  }
}
